import httpClient from "../../api/httpClient";
import Grupo from "../classes/GrupoBroadcast";
import { GrupoEmail, GrupoEmailPost } from "../classes/GrupoBroadcastEmail";
import { RotinaGrupo } from "../classes/RotinaGrupoBroadcast";

interface HttpCalls {
    method: string;
    rota: string;
}

const calls: HttpCalls[] = [
    { method: "POST", rota: "Broadcast/RotinaGrupoBroadcastEmail/Adicionar" },
    { method: "DELETE", rota: "Broadcast/RotinaGrupoBroadcastEmail/Apagar" },
    { method: "POST", rota: "Broadcast/Desvincular/Rotina/" }
];

const cacheKey: string = "RotinaGrupoCache";
const cacheKeySelC: string = "RotinaGrupoSelecionado";

const apiServico: string = "PORTAL";

class RotinaGrupoDataset extends httpClient {

    constructor() {
        super(String(apiServico));
    }

    async Adicionar(value: RotinaGrupo) {
        return super.post(calls[0].rota, value)
            .then((result) => {
                return JSON.parse(result);
            }).catch((erro) => {
                console.error(erro);
            });
    }

    async Apagar(value: RotinaGrupo) {
        return super.delete(calls[1].rota, value)
            .then((result) => {
                return JSON.parse(result);
            }).catch((erro) => {
                console.error(erro);
            });
    }

    async Desvincular(idRotina: number, idGrupo: number) {
        return super.post(calls[2].rota + idRotina + '/Grupo/' + idGrupo, null)
            .then((result) => {
                return JSON.parse(result);
            }).catch((erro) => {
                console.error(erro);
            });
    }

    getKeyCach(): string {
        return cacheKey;
    }

    getKeyCachClass(): string {
        return cacheKeySelC;
    }

    ListarFromCache(): RotinaGrupo[] {
        let result: RotinaGrupo[] = JSON.parse(cacheKey);
        return result;
    }

    AdicionarListaAoCache(value: RotinaGrupo[]) {
        localStorage.setItem(cacheKey, JSON.stringify(value));
    }

    LimparListaDoCache() {
        localStorage.removeItem(cacheKey);
    }

    AdicionarObjetoAoCache(value: RotinaGrupo) {
        localStorage.setItem(cacheKeySelC, JSON.stringify(value));
    }

    LimparObjetoDoCache() {
        localStorage.removeItem(cacheKeySelC);
    }

}
export default RotinaGrupoDataset;